import React, { lazy, Suspense } from 'react';

const iconImports = {
  assitantBlue: () => import('@/assets/icons/assitantBlue.svg?react'),
  assitantChat: () => import('@/assets/icons/assitantChat.svg?react'),
  assitantWhite: () => import('@/assets/icons/assitantWhite.svg?react'),
  close: () => import('@/assets/icons/close.svg?react'),
  export: () => import('@/assets/icons/export.svg?react'),
  send: () => import('@/assets/icons/send.svg?react'),
  trash: () => import('@/assets/icons/trash.svg?react'),
  refresh: () => import('@/assets/icons/refresh.svg?react'),
  dots: () => import('@/assets/icons/dots.svg?react'),
  backArrow: () => import('@/assets/icons/backArrow.svg?react'),
  doubleDownArrow: () => import('@/assets/icons/doubleDownArrow.svg?react'),
  expand: () => import('@/assets/icons/expand.svg?react'),
  collapse: () => import('@/assets/icons/collapse.svg?react'),
  assistantFace: () => import('@/assets/icons/assistantFace.svg?react'),
  chatClosed: () => import('@/assets/icons/chatClosed.svg?react'),
};

export type IconName = keyof typeof iconImports;

interface CustomIconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
}

const lazyIcons = Object.fromEntries(
  Object.entries(iconImports).map(([name, importFn]) => [name, lazy(importFn)])
) as Record<IconName, React.LazyExoticComponent<React.ComponentType<unknown>>>;

const CustomIcon: React.FC<CustomIconProps> = ({ name, ...props }) => {
  if (!name || !lazyIcons[name]) {
    return null;
  }

  const IconComponent = lazyIcons[name];

  return (
    <Suspense fallback={<span style={{ width: props.width, height: props.height }} />}>
      <IconComponent {...props} />
    </Suspense>
  );
};

export default CustomIcon;
